import WorkShiftSearchComponent from "./WorkShiftSearchComponent.vue";
import WorkShiftListComponent from "./WorkShiftListComponent.vue";
import WorkShiftDetailModal from "./WorkShiftDetailModal.vue";

export { WorkShiftSearchComponent, WorkShiftListComponent, WorkShiftDetailModal };
